// useCourseData.js
import React from 'react';
import { useGetModules } from '../../api/endpoints/modules/modules';
import { useAppStateStore } from '../../context/AppStateStore';
import log from '../../utils/logger';

export const useCourseData = () => {
  const selectedModule = useAppStateStore((state) => state.selectedModule);
  const clearSelection = useAppStateStore((state) => state.clearSelection);
  const {
    data: modules,
    isLoading,
    isError,
    error,
    refetch: refetchCourseData,
  } = useGetModules(
    undefined, // no params needed
    {
      query: {
        staleTime: 1000 * 60 * 10, // 10 minutes
        select: (data) => data?.data?.data ?? [], // Simplified null check with nullish coalescing
      },
    },
  );

  // Validate selected module against modules list
  React.useEffect(() => {
    if (
      !isLoading
      && selectedModule?.moduleId
      && selectedModule.moduleId !== 'undefined'
      && modules?.length > 0
    ) {
      const foundModule = modules.find(
        (m) => m.id === selectedModule?.moduleId && m.courses.some((c) => c.id === selectedModule?.courseId),
      );

      // Clear selection if module/course combination is invalid
      if (!foundModule) {
        // Expected recovery when persisted selection no longer matches the
        // modules list (unenrolled, unpublished, stale local state). warn =
        // Sentry breadcrumb only; error would file FLARE-45 noise.
        log.warn('Selected module/course combination not found - clearing selection', {
          selectedModuleId: selectedModule?.moduleId,
          selectedCourseId: selectedModule?.courseId,
          availableModules: modules.map((m) => ({
            id: m.id,
            courses: m.courses.map((c) => c.id),
          })),
        });
        // Clear invalid state to prevent infinite loops
        clearSelection();
      }
      // Note: We no longer auto-deselect submitted/graded modules.
      // "Selected module" represents active work context (ModuleScreen).
      // GradeScreen is independent and uses route params only.
    }
  }, [modules, selectedModule, isLoading, clearSelection]);

  return {
    modules,
    refetchCourseData,
    isLoading,
    isError,
    error,
  };
};

export default useCourseData;
